import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Storage } from 'react-jhipster';
import '../scolarite/scolarite.scss';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Col, Row } from 'antd';
import axios from 'axios';
import CountUp from 'react-countup';

type SuiviSalaireProps = {
  salaireGroupId: string;
};

const SuiviSalaire: React.FC<SuiviSalaireProps> = ({ salaireGroupId }) => {
  const dispatch = useAppDispatch();
  const [nombreSalairesPaye, setNombreSalairesPaye] = useState(0);
  const [nombreSalairesNonPaye, setNombreSalairesNonPaye] = useState(0);
  const [nombreSalairesEnAttente, setNombreSalairesEnAttente] = useState(0);
  const [totalNetPaye, setTotalNetPaye] = useState(0);
  const [totalNetEnAttente, setTotalNetEnAttente] = useState(0);
  const [totalNetNonPaye, setTotalNetNonPaye] = useState(0);
  const [totalNet, setTotalNet] = useState(0);
  const [totalFrais, setTotalFrais] = useState(0);
  const [totalWave, setTotalWave] = useState(0);
  const [totalOM, setTotalOm] = useState(0);
  const [totalBRS, setTotalBRS] = useState(0);
  const [loading, setLoading] = useState(true);
  const apiUrl = `api/salaire/dashboard/${salaireGroupId}`;
  const token = Storage.local.get('jhi-authenticationToken') || Storage.session.get('jhi-authenticationToken');
  const getDashbord = () => {
    if (token) {
      axios
        .get(`${apiUrl}`, {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        })
        .then(response => {
          setLoading(!loading);
          setNombreSalairesPaye(response.data.totalPaye);
          setNombreSalairesNonPaye(response.data.totalNonPaye);
          setNombreSalairesEnAttente(response.data.totalEnAttente);
          setTotalNetPaye(response.data.totalNetPaye);
          setTotalNetEnAttente(response.data.totalNetEnAttente);
          setTotalNetNonPaye(response.data.totalNetNonPaye);
          setTotalNet(response.data.totalNet);
          setTotalBRS(response.data.totalRetenueBRS);
          setTotalFrais(response.data.totalFrais);
          setTotalOm(response.data.totalOM);
          setTotalWave(response.data.totalWave);
        });
    }
  };

  useEffect(() => {
    getDashbord();
  }, []);

  const chartData1 = {
    labels: ['Montant Net', 'Retenue BRS', 'Frais'],
    datasets: [
      {
        data: [totalNet, totalBRS, totalFrais],
        backgroundColor: ['rgba(75,192,192,1.5)', '#bf616a', '#ffcb75'],
        hoverBackgroundColor: ['rgba(75,192,192,1.5)', '#F08080', 'rgb(255,203,117,0.7)'],
      },
    ],
  };

  const chartData2 = {
    labels: ['Paye', 'Non_Paye', 'En_Attente'],
    datasets: [
      {
        data: [
          { value: nombreSalairesPaye, description: totalNetPaye },
          { value: nombreSalairesNonPaye, description: totalNetNonPaye },
          { value: nombreSalairesEnAttente, description: totalNetEnAttente },
        ],
        backgroundColor: ['#17a2b8', '#FF6384', '#ECEA48'],
        hoverBackgroundColor: ['#17a2b8', '#FF6384', '#ECEA48'],
      },
    ],
  };
  const options2 = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom' as const,
      },
      tooltip: {
        callbacks: {
          label(tooltipItem: { datasetIndex: string | number; dataIndex: string | number }) {
            const dataPoint = chartData2.datasets[tooltipItem.datasetIndex].data[tooltipItem.dataIndex];
            return `${chartData2.labels[tooltipItem.dataIndex]}: ${dataPoint.value} (${dataPoint.description})`;
          },
        },
      },
    },
    cutout: '60%',
  };
  const options1 = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom' as const,
      },
    },
    cutout: '60%',
  };
  const chartData3 = {
    labels: ['Wave', 'OMoney', 'Frais'],
    datasets: [
      {
        data: [totalWave, totalOM, totalFrais],
        backgroundColor: ['#1cc8ff', '#F4810D', '#ffcb75'],
      },
    ],
  };

  return (
    <div className="suivi-scolarite-container">
      <h2>SUIVI SALAIRE</h2>
      <div className="chart-container">
        <>
          <div className="chart-title">
            Montant Total de l&apos;opération:&nbsp;
            <strong>
              <CountUp end={totalNet + totalFrais} separator="." /> FCFA
            </strong>
          </div>
          <Row justify="space-around">
            <Col xs={{ span: 14 }} lg={{ span: 7 }}>
              <Doughnut data={chartData1} options={options1} />
              <p>Montant Global</p>
            </Col>
            <Col xs={{ span: 14 }} lg={{ span: 7 }}>
              <Doughnut data={chartData3} options={options1} />
              <p>Répartition Wave/OMoney</p>
            </Col>

            <Col xs={{ span: 14 }} lg={{ span: 7 }}>
              <Doughnut data={chartData2} options={options2} />
              <p>Nombre de salaires</p>
            </Col>
          </Row>
        </>
      </div>
    </div>
  );
};

export default SuiviSalaire;
